// @flow
import { connect } from 'react-redux'
import BudgetSelect from './BudgetSelect'
import type { Store } from '../../redux/ducks'
import type { State as AudienceState } from '../../redux/ducks/audienceEdit/reducers'
import { patch } from '../AudienceEditContainer'

function mapStateToProps(state: Store) {
  const audienceState = state.audienceEdit
  const initial = audienceState.initial

  if (!initial) return {}

  return {
    cycleOptions: initial.budget.cycleOptions,
    minMonthBudget: initial.budget.minMonthBudget,
    minDailyBudget: initial.budget.minDailyBudget,
    maxBudget: initial.budget.maxBudget,
    errors: audienceState.budgetErrors,
    budgetCycle: audienceState.budgetCycle,
    budget: audienceState.budget,
    isBudgetCycleDisabled: initial.action === 'create'
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onChange: (diff: $Shape<AudienceState>) => patch(dispatch, diff)
  }
}

const BudgetSelectContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(BudgetSelect)

export default BudgetSelectContainer
